import React, { useState } from 'react';
import {
  MenuPopUp,
  MenuToggleButton,
} from 'src/components/regions-menu/toggle-menu';
import { Status } from 'src/graphql/types';
import { useMenuState } from 'src/hooks/use-menu-state';
import { MangoBrightBlue, White } from 'src/styles/colours';
import { DemiBold } from 'src/styles/fonts';
import styled from 'styled-components';
import { toDisplayStatus } from '../status-badge/status-badge';
import { StatusMenuPopupContents } from './menu-contents';

export const ALL_STATUSES: Array<NonNullable<Status>> = [
  'DELIVERED',
  'INVOICED',
  'PART_DELIVERED',
  'PART_INVOICED',
  'PART_SHIPPED',
  'PROCESSED',
  'RECEIVED',
  'SHIPPED',
  'REJECTED',
  'POTENTIAL',
];

const StyledPill = styled.span<{ active: boolean }>`
  display: inline-block;
  border-radius: 2rem;
  background-color: ${({ active }) => (active ? MangoBrightBlue : White)};
  padding: 0rem 1rem;
  line-height: 2.25rem;
  color: ${({ active }) => (active ? White : MangoBrightBlue)};
  border: 1px solid ${MangoBrightBlue};
  font-family: ${DemiBold};
  margin-left: 1rem;
  cursor: pointer;
`;

const StyledMenuPopUp = styled(MenuPopUp)`
  left: 1rem;
  right: auto;
  box-shadow: 0 2px 8px 0 rgba(66, 66, 74, 0.25);
  top: 50px;
  &:before {
    left: 25%;
    right: auto;
  }
`;

const Pill = ({ statuses }: { statuses: Status[] }) => {
  let content = 'Order status';

  if (statuses.length < 3 && statuses.length > 0) {
    content = statuses
      .map(status => status && toDisplayStatus(status))
      .join(', ');
  } else if (statuses.length > 2) {
    content = `Order status: ${statuses.length} selected`;
  }

  return <StyledPill active={statuses.length > 0}>{content}</StyledPill>;
};

export const StatusFilter = ({
  statuses: selectedStatuses,
  statusCounts,
  applyStatusFilter,
}: {
  statuses: Status[];
  statusCounts: { [key in NonNullable<Status>]: number };
  applyStatusFilter: (statuses: Status[]) => void;
}) => {
  const { displayed, setDisplayed, menuRef } = useMenuState();

  const [filters, setFilters] = useState(selectedStatuses);

  const onToggle = (toggle: boolean, status: Status) => {
    setFilters(
      toggle ? [...filters, status] : filters.filter(s => s !== status)
    );
  };

  const onToggleAll = (toggle: boolean) => {
    setFilters(toggle ? ALL_STATUSES : []);
  };

  const onCloseMenu = () => {
    setDisplayed(false);
    setFilters(selectedStatuses);
  };

  const onApply = () => {
    applyStatusFilter(filters);
    setDisplayed(false);
  };

  return (
    <div ref={menuRef}>
      <MenuToggleButton displayed={displayed} setDisplayed={setDisplayed}>
        <Pill statuses={selectedStatuses} />
      </MenuToggleButton>
      <StyledMenuPopUp displayed={displayed} setDisplayed={setDisplayed}>
        <StatusMenuPopupContents
          filters={filters}
          statusCounts={statusCounts}
          onToggle={onToggle}
          onToggleAll={onToggleAll}
          onClose={onCloseMenu}
          onApply={onApply}
        />
      </StyledMenuPopUp>
    </div>
  );
};
